import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { db } from './firebase/config.js';
import { initializeAnalytics } from './services/analytics';

// Initialize GA4
initializeAnalytics();

// Make sure Firebase is initialized before rendering
if (!db) {
  throw new Error('Firebase failed to initialize');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();